import { DomainError } from '@dma/shared';

export class InvalidBannerError extends DomainError {
  constructor(reason: string) {
    super('INVALID_BANNER', `Banner is invalid: ${reason}`);
    this.name = 'InvalidBannerError';
    Object.setPrototypeOf(this, InvalidBannerError.prototype);
  }
}
